import { motion, useScroll, useTransform } from "framer-motion";
import { useRef, useState } from "react";
import DarkVeil from './DarkVeil';
import TextType from './TextType';
import MagicBento from './MagicBento';

const NAV = [
  { id: 'projects', label: 'Projects' },
  { id: 'experience', label: 'Experience' },
  { id: 'education', label: 'Education' },
  { id: 'connect', label: 'Connect' },
];

export default function Portfolio() {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: containerRef, offset: ["start start", "end end"] });
  const fadeOut = useTransform(scrollYProgress, [0, 0.2], [1, 0]);
  const cueOpacity = useTransform(scrollYProgress, [0, 0.06], [1, 0]);
  const [titleDone, setTitleDone] = useState(false);

  return (
    <div ref={containerRef} className="min-h-screen overflow-x-hidden text-white relative" style={{ backgroundColor: '#060010' }}>
      {/* DarkVeil Background */}
      <div className="fixed inset-0 w-full h-full z-0">
        <DarkVeil
          hueShift={0}
          noiseIntensity={0.01}
          scanlineIntensity={0.05}
          speed={0.2}
          scanlineFrequency={0.3}
          warpAmount={0.05}
          resolutionScale={1}
        />
      </div>

      {/* Floating section nav */}
      <nav className="fixed top-6 left-1/2 -translate-x-1/2 z-30 hidden md:flex items-center gap-1 rounded-full border border-white/10 bg-black/30 backdrop-blur-md px-2 py-1.5">
        {NAV.map((n) => (
          <a
            key={n.id}
            href={`#${n.id}`}
            className="px-3.5 py-1.5 text-sm text-white/60 hover:text-white rounded-full hover:bg-white/10 transition-colors"
          >
            {n.label}
          </a>
        ))}
      </nav>

      {/* Content */}
      <div className="relative z-10">
        {/* Hero */}
        <section className="flex flex-col items-center justify-center h-screen px-6 text-center">
          <motion.div style={{ opacity: fadeOut }} className="text-5xl md:text-6xl font-bold text-white drop-shadow-lg">
            <TextType
              as="h1"
              text="Hello, my name is Jan."
              typingSpeed={40}
              showCursor={!titleDone}
              cursorCharacter="|"
              deleteText={false}
              onComplete={() => setTitleDone(true)}
            />
          </motion.div>
          <motion.div
            style={{ opacity: fadeOut }}
            className="mt-4 text-lg md:text-xl text-white/70 font-normal max-w-xl"
          >
            {titleDone && (
              <TextType
                as="p"
                text="An AI software developer who builds intelligent automations and web experiences."
                typingSpeed={30}
                initialDelay={200}
                showCursor={true}
                cursorCharacter="|"
                deleteText={false}
              />
            )}
          </motion.div>

          {/* Scroll cue */}
          <motion.a
            href="#projects"
            style={{ opacity: cueOpacity }}
            className="absolute bottom-10 flex flex-col items-center gap-2 text-white/40 hover:text-white/70 transition-colors"
          >
            <span className="text-xs uppercase tracking-[0.3em]">Scroll</span>
            <motion.span
              animate={{ y: [0, 8, 0] }}
              transition={{ duration: 1.6, repeat: Infinity, ease: 'easeInOut' }}
              className="text-xl"
            >
              ↓
            </motion.span>
          </motion.a>
        </section>

        {/* Content sections */}
        <section className="flex flex-col items-center justify-center px-4 sm:px-6 pb-32">
          <MagicBento />
        </section>
      </div>
    </div>
  );
}
